import { render, staticRenderFns } from "./TaskDetailComponent.vue?vue&type=template&id=59d467f2&scoped=true&"
import script from "./TaskDetailComponent.vue?vue&type=script&lang=js&"
export * from "./TaskDetailComponent.vue?vue&type=script&lang=js&"
import style0 from "./TaskDetailComponent.vue?vue&type=style&index=0&id=59d467f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d467f2",
  null
  
)

export default component.exports